import { ReactElement, useContext } from "react"

import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { AmendEbDeviceContext } from "../providers/baseProviders/amendEbDeviceProvider"

const NON_SYS_ADMIN_EB_STEPS_AMEND = [
    "Core Electric Boiler Details",
    "Upload Supporting Files",
    "Review and Submit",
]

/** AppStepper for amending an Electric Boiler device */
const AmendEbDeviceProgressStepper = (): ReactElement => {
    const { currentIndex } = useContext(AmendEbDeviceContext)

    return (
        <AppStepper
            stepLabels={NON_SYS_ADMIN_EB_STEPS_AMEND}
            currentStepIndex={currentIndex}
        />
    )
}

export default AmendEbDeviceProgressStepper
